import React, { useEffect, useState } from "react"
import * as routes from "../../Router/RoutesURL";
import { useNavigate, useSearchParams } from "react-router-dom";
import AppContainer from "../../components/AppContainer/AppContainer"
import { Tab, Tabs } from "react-bootstrap";
import GuestUser from "./GuestUser/GuestUser"
import TeamMembers from "./TeamMembers/TeamMembers"
import AccessManagement from "./AccessManagement/AccessManagement"
import UserRole from "./UserRole/UserRole"
import { Button } from "reactstrap";
import { getPermissionByAppName } from "../../utils/Helper"
import WhitePlus from "../../assets/images/CommonComponent/WhitePlus.svg"
import "./UserManagementDashboard.scss"
import Downloads from "./Downloads/Downloads";
import { DeleteRequest } from "./DeleteRequest/DeleteRequest";
import { tabKeys } from "../../Config/Constant";

const USER_MANAGEMENT_TABS = [
    {
      key: tabKeys.userManagement.GUEST_USER,
      title: tabKeys.userManagement.GUEST_USER,
      permissionKey: "Guest User Management",
      Component: GuestUser,
    },
    {
      key: tabKeys.userManagement.DOWNLOADS,
      title: tabKeys.userManagement.DOWNLOADS,
      permissionKey: "Guest User Management",
      Component: Downloads,
    },
    {
      key: tabKeys.userManagement.TEAM_MEMBER,
      title: tabKeys.userManagement.TEAM_MEMBER,
      permissionKey: "Team User Management",
      Component: TeamMembers,
    },
    {
      key: tabKeys.userManagement.USER_ROLE,
      title: tabKeys.userManagement.USER_ROLE,
      permissionKey: "Role User Management",
      Component: UserRole,
      extraProps: {
        selection: "add",
      },
    },
    {
      key: tabKeys.userManagement.ACCESS_MANAGEMENT,
      title: tabKeys.userManagement.ACCESS_MANAGEMENT,
      permissionKey: "Access User Management",
      Component: AccessManagement,
    },
    {
      key: tabKeys.userManagement.DELETE_REQUESTS,
      title: tabKeys.userManagement.DELETE_REQUESTS,
      permissionKey: "Delete Request",
      Component: DeleteRequest,
    },
  ];
  

const UserManagementDashboard=(props)=> {
    const { history } = props;
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams();
    const [activeTab, setActiveTab] = useState("");
    const [showConfirm, setShowConfirm] = useState(false);

    useEffect(() => {
        const tab = searchParams.get("tab");
        if (tab) {
            setActiveTab(tab);
        } else {
            let defaultTab = tabKeys.userManagement.ACCESS_MANAGEMENT;
            if (getPermissionByAppName("Guest User Management") !== "hide")
                defaultTab = tabKeys.userManagement.GUEST_USER;
            else if(getPermissionByAppName("Team User Management") !== "hide")
                defaultTab = tabKeys.userManagement.TEAM_MEMBER;
            else if(getPermissionByAppName("Role User Management") !== "hide")
                defaultTab = tabKeys.userManagement.USER_ROLE;
            else if(getPermissionByAppName("DeleteRequest") !== "hide")
                defaultTab = tabKeys.userManagement.DELETE_REQUESTS;
            setActiveTab(defaultTab);
        }
    }, [searchParams]);

    const handleClick = (e) => {
        if (activeTab == tabKeys.userManagement.GUEST_USER) {
            navigate(routes.ADD_USER);
        }
        else if (activeTab == tabKeys.userManagement.TEAM_MEMBER) {
            navigate(routes.ADD_MEMBER, { state: { selection: "add" } })
        }
    };

    const handleTabSelect = (index) => {
        if(index!==activeTab){
            const newParams = new URLSearchParams();
            newParams.set("tab", index);
            setSearchParams(newParams);
            setActiveTab(index);
        }
    };

    const handleSet = () => {
        setShowConfirm(true);
    };


    return (
        <AppContainer history={history}>
            <div className="event-table  user-management-table">
                <div className="UserMangTabsContainer">
                    <div className="buttonDiv">
                        {/* {activeTab == "GuestUser" && getPermissionByAppName("Guest User Management") === "write" &&<Button className="btn btn-primary mt-2 addUser" type="submit" onClick={handleClick}>
                            <img className="mr-2 mb-1 " src={WhitePlus} alt="" width="14px" height="14px" />New User
                        </Button>} */}
                        {activeTab ==tabKeys.userManagement.TEAM_MEMBER && getPermissionByAppName("Team User Management") === "write" &&<Button className="btn btn-primary mt-2 addUser" type="submit" onClick={handleClick}>
                            <img className="mr-2 mb-1 " src={WhitePlus} alt="" width="14px" height="14px" />New Member
                        </Button>}
                        {activeTab == tabKeys.userManagement.USER_ROLE && getPermissionByAppName("Role User Management") === "write" &&<Button className="btn btn-primary mt-2 addUser" type="submit" onClick={handleSet} >
                            <img className="mr-2 mb-1 " src={WhitePlus} alt="" width="14px" height="14px" />New Role
                        </Button>}
                    </div>
                    <Tabs
                        id="controlled-tab-example"
                        className="TabsDiv"
                        activeKey={activeTab}
                        onSelect={handleTabSelect}
                        >
                        {USER_MANAGEMENT_TABS.map(
                            ({ key, title, permissionKey, Component, extraProps }) => {
                            const permission = getPermissionByAppName(permissionKey);

                            if (permission === "hide") return null;

                            return (
                                <Tab key={key} eventKey={key} title={title}>
                                {activeTab === key && (
                                    <Component
                                    showConfirm={showConfirm} setShowConfirm={setShowConfirm}
                                    activeTab={activeTab}
                                    permission={permission}
                                    {...extraProps}
                                    />
                                )}
                                </Tab>
                            );
                            }
                        )}
                        </Tabs>

                </div>
            </div>
        </AppContainer >
    )
}

export default UserManagementDashboard
